module.exports = __webpack_public_path__ + "static/img/r-2-2.b53b53e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/role-2/r-2-2.png
// module id = qPdf
// module chunks = 0